module.exports = __webpack_public_path__ + "assets/img/my-vip-bottom-note.f404ac49.png";